const urls = {
  base: '/inquiry',

  confirm: '/confirm',
  consent: '/consent',
  completion: '/completion',
};

export function inquiryUrl(type: string): string {
  if (type === 'account') {
    return urls.base + '?type=' + type;
  } else {
    return urls.base + '/';
  }
}

export function confirmUrl(type: string): string {
  if (type === 'account') {
    return urls.base + urls.confirm + '?type=' + type;
  } else {
    return urls.base + urls.confirm + '/';
  }
}

export function consentUrl(type: string): string {
  if (type === 'account') {
    return urls.base + urls.consent + '?type=' + type;
  } else {
    return urls.base + urls.consent + '/';
  }
}

export function completionUrl(type: string): string {
  if (type === 'account') {
    return urls.base + urls.completion + '?type=' + type;
  } else {
    return urls.base + urls.completion + '/';
  }
}

export default urls;
